import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import { buildFileDownloadUrl, getApiBaseUrl } from '../../utils/apiConfig';
import FluidGallery from '../../pages/Gallary/components/FluidGallery';

const isImage = (mime = '', name = '') => {
  const m = String(mime || '').toLowerCase();
  if (m.startsWith('image/')) return true;
  const n = String(name || '').toLowerCase();
  return ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp'].some((ext) => n.endsWith(ext));
};

const buildFileName = (row) => row?.OriginalName || row?.StoredName || `File-${row?.FileLibraryId || 'NA'}`;

const stripExtension = (filename = '') => {
  const s = String(filename || '').trim();
  if (!s) return '';
  const lastDot = s.lastIndexOf('.');
  if (lastDot <= 0) return s;
  return s.slice(0, lastDot);
};

export default function VehiclePhotoModal({ vehicleId, vehicleLabel, onClose }) {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const apiBase = getApiBaseUrl();

  useEffect(() => {
    const fetchFiles = async () => {
      if (!apiBase || !vehicleId) return;
      setLoading(true);
      try {
        const res = await axios.post(`${apiBase}/file/list`, { entityType: 'vehicle', entityId: vehicleId });
        const list = Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data?.data?.[0])
            ? res.data.data[0]
            : [];
        setFiles(Array.isArray(list) ? list : []);
      } catch (_) {
        setFiles([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFiles();
  }, [apiBase, vehicleId]);

  const photos = useMemo(() => {
    return (files || [])
      .filter((f) => isImage(f?.MimeType, f?.OriginalName))
      .map((f, idx) => {
        const id = f?.FileLibraryId ?? idx;
        const name = stripExtension(buildFileName(f));
        const url = f?.FileLibraryId ? buildFileDownloadUrl(f.FileLibraryId) : '';
        return { id, title: name, url, thumbUrl: url };
      });
  }, [files]);

  return (
    <Modal
      show
      fullscreen
      onHide={onClose}
      backdrop="static"
      className="sk-vehicle-gallery-modal"
      backdropClassName="sk-vehicle-gallery-backdrop"
    >
      <ModalHeader closeButton>
        <ModalTitle>{vehicleLabel || 'Vehicle'} - Photos</ModalTitle>
      </ModalHeader>
      <ModalBody>
        {loading ? <div className="text-muted small mb-2">Loading...</div> : null}
        <div className="sk-gallery-shell">
          <div className="sk-gallery-shell-scroll">
            <FluidGallery images={photos} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

